module.exports = __webpack_public_path__ + "static/media/Netflix.046cd3d6.png";